{
  "allApps": "Todas las aplicaciones",
  "back": "Volver a principal",
  "myApps": "Mis aplicaciones",
  "viewMoreApps": "Vista de más aplicaciones"
}
